declare const pendo: any | undefined;

// For pendo, event types can ONLY be lowercast letters, numbers, and undercores
export enum AnalyticEventType {
  LANDING_QUERY = 'landing_query',
  POLICY_SEARCH = 'policy_search',
  VISITOR_RESOLUTION = 'visitor_resolution',
}

export const fireAnalyticEvent = ({
  type,
  metadata,
}: {
  type: AnalyticEventType;
  metadata?: {};
}): void => {
  if (process.env.NODE_ENV === 'test') {
    return;
  }

  try {
    if (pendo && pendo.isReady && pendo.isReady()) {
      pendo.track(type, {
        accountId: pendo.getAccountId(),
        visitorId: pendo.getVisitorId(),
        ...metadata,
      });
    }
  } catch (error) {
    // swallow this error because we don't want it to effect the normal
    // application experience
    return;
  }
};
